import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSwal from "vue-swal";
import firebase from "firebase";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// https://medium.com/front-end-weekly/how-to-use-fon-awesome-5-on-vuejs-project-ff0f28310821
// https://fontawesome.com/icons?d=gallery&q=plus&s=solid&m=free
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faMinus,
  faTrash,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { formatMoney } from "./filters/priceFormatter";
import { brandFilter } from "./filters/brandFilter";
import { phoneTextFilter } from "./filters/phoneTextFilter";

library.add(faPlus);
library.add(faMinus);
library.add(faTrash);
library.add(faSearch);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.filter("priceFormatter", formatMoney);
Vue.filter("brandFilter", brandFilter);
Vue.filter("phoneTextFilter", phoneTextFilter);

Vue.use(VueSwal);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

export const bus = new Vue();

const firebaseConfig = {
  apiKey: "AIzaSyC9qrIYKjgrbVCVeVQ1CGmbkcw3Se2rUdY",
  authDomain: "api-project-1031398239957.firebaseapp.com",
  databaseURL:
    "https://api-project-1031398239957-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "api-project-1031398239957",
  appId: "1:1031398239957:web:417bbd9abcf25d57213c5c"
};

firebase.initializeApp(firebaseConfig);

let app;

firebase.auth().onAuthStateChanged(user => {
  console.log("user", user);
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});
